// 生产接口地址。
// 注意：站点是 https，这里必须是 https，否则浏览器会按 mixed content 拦截所有 XHR，
// 表现为页面能打开但数据一直加载 / 白屏（见飞书 rec zz28PUrm0SH2v）。
// 优先读构建期环境变量，方便以后切换环境不再改源码。
const baseURL = process.env.VUE_APP_API_BASE || 'https://api.chicchinails.com/'

export default {
    baseURL
}
